import React from 'react';
import { RiskManagement, AssetDetails, InspectionDetails } from '.';
import { addRouteNamespace } from '@Utils/actions';
import RiskManagementList from './RiskManagementList';

// NOTE WE DONT NEED TO TRANSLATE THESE AS MOST ARE NEVER SHOWN
export const mainPageRoutes = [
	{
		title: 'Results',
		to: addRouteNamespace('results/:configId'),
		render: <RiskManagement page={0} />,
	},
	{
		title: 'Likelihood of Failure Setup',
		to: addRouteNamespace('lofSetup/:configId'),
		render: <RiskManagement page={1} />,
	},
	{
		title: 'Consequence of Failure Setup',
		to: addRouteNamespace('cofSetup/:configId'),
		render: <RiskManagement page={2} />,
	},
	{
		title: 'Risk Setup',
		to: addRouteNamespace('riskSetup/:configId'),
		render: <RiskManagement page={3} />,
	},
	{
		title: 'Risk Log',
		to: addRouteNamespace('riskLog/:configId'),
		render: <RiskManagement page={4} />,
	},
	{
		title: 'Asset Details',
		to: addRouteNamespace('riskAssetDetails/:assetId'),
		render: <AssetDetails />,
	},
	{
		title: 'Inspection Details',
		to: addRouteNamespace('riskInspectionDetails/:standard/:inspectionId'),
		render: <InspectionDetails />,
	},
];

export const miniPageRoutes = [
	{
		title: 'Risk',
		to: '/risk',
		icon: <img src={require('./repo-icon.svg')} alt="risk" />,
		render: <RiskManagement />,
	},
	...mainPageRoutes,
];

export const miniPageRoutesMulti = [
	{
		title: 'Risk',
		to: '/risk',
		icon: <img src={require('./repo-icon.svg')} alt="risk" />,
		render: <RiskManagementList />,
	},
	...mainPageRoutes,
];

export default [mainPageRoutes, miniPageRoutes];
